

















































import { mapGetters } from 'vuex';

import {
  getInitialBalanceUndergroundCasinoConfiguration,
  updateInitialBalanceUndergroundCasinoConfiguration
} from '@/api/CopyStake/Settings';
import {
  ValidationRule,
  TCopyStakeSettingsInitialBalanceUndergroundCasinoResponse,
  TCopyStakeSettingsInitialBalanceUndergroundCasinoPayload
} from '@/api/schema';

import Tooltip from '@/components/tooltip/Tooltip.vue';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { isEqual } from 'lodash';
import type { AxiosError } from 'axios';
import * as vr from '@/helpers/validation';

export default {
  name: 'CopyStakeSettingsInitialBalanceUndergroundCasino',
  components: {
    Tooltip
  },
  data(): any {
    return {
      initialBalanceSavedData: null,
      initialBalance: null,

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    initialBalanceChanged(): boolean {
      return !isEqual(this.initialBalance, this.initialBalanceSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.initialBalanceChanged;
    },

    initialBalanceRules(): ValidationRule[] {
      return this.initialBalance
        ? [vr.positiveNumber, vr.validNumber, vr.integer]
        : [];
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    parseSettingsData(
      data: TCopyStakeSettingsInitialBalanceUndergroundCasinoResponse
    ): void {
      const parsedData = String(data.targetBalance ?? '');

      this.initialBalanceSavedData = parsedData;
      this.initialBalance = parsedData;
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getInitialBalanceUndergroundCasinoConfiguration()
        .then(
          (
            data: TCopyStakeSettingsInitialBalanceUndergroundCasinoResponse
          ) => {
            this.parseSettingsData(data);
          }
        )
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeSettingsInitialBalanceUndergroundCasinoPayload =
        {
          targetBalance: this.initialBalance,
          currency: this.initialBalance ? 'USDT' : null
        };

      await updateInitialBalanceUndergroundCasinoConfiguration(payload)
        .then(
          (
            data: TCopyStakeSettingsInitialBalanceUndergroundCasinoResponse
          ) => {
            this.parseSettingsData(data);

            this.$toast.success('Initial Balance was successfully updated!');
          }
        )
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
